"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommentsCountEmptyValue = void 0;
const getCommentsCountEmptyValue = () => 0;
exports.getCommentsCountEmptyValue = getCommentsCountEmptyValue;
